import React from 'react';
import '../styles/coin.css';



const Coin = ({ image, name, symbol, price, priceChange, volume, nairaRate }) => {
    return (
        <div className='coin-container'>
         <div className='coin-row'>
          <div className='market'>
          <p><img src={image} alt={name} /></p>
          <p className='symbol'>{name}</p>
          <p className='symbol'>{symbol.toUpperCase()}/NGN</p>
          </div>
          <div className='market-data'>
              <ul>
          {(price * nairaRate) > 0.0005 ? (
             <li>N{(parseFloat(price) * nairaRate).toLocaleString()}</li>
          ) : (
            <li>NAN</li>
          )}
            
          {priceChange < 0 ? (
            <li className='coin-percent red'>{parseFloat(priceChange).toFixed(2)}%</li>
          ) :
          (
            <li className='coin-percent green'>{parseFloat(priceChange).toFixed(2)}%</li>
          )}
          <li>${volume.toLocaleString()}</li> 
             </ul>
          </div>
         </div>
        </div>
    )
}


export default Coin;